import API, { handleRequest } from '@/api/lib/api'

export const getCustomerCbd = (restaurant_id, params) =>
  handleRequest(() =>
    API.get(`restaurant/${restaurant_id}/cbd/customers`, { params })
  )

export const getCustomerCbdOrder = (restaurant_id, customer_id, params) =>
  handleRequest(() =>
    API.get(`restaurant/${restaurant_id}/cbd/customers/${customer_id}/orders`, {
      params
    })
  )

export const getSingleOrderCbd = order_id =>
  handleRequest(() => API.get(`restaurant/order/${order_id}`))
